
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import VueAos from 'vue-aos'
import Entry from "@/models/entry";
import AOS from 'aos';
import SeeMore from '@/components/SeeMore.vue';

const namespace = "PostsModule";

@Component({
  components: {
    VueAos,
    SeeMore
  }
})

export default class Home extends Vue{
  @Action('fetchData', { namespace }) private fetchData!: () => any;
  @State('entries', { namespace }) private entries!: () => Entry[];
  @State('loading', { namespace }) private loading!: () => boolean;
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private async created(){
    await this.fetchData();
  }

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
  }

};
